import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-align-top-02',
  imports: [],
  templateUrl: './align-top-02.html',
  styleUrl: './align-top-02.scss',
})
export class AlignTop02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
